export default {
  paper: {
    borderRadius: "0",
    boxShadow: "-5px 5px 15px -5px rgba(0,0,0,0.75)",
    background: "#222222",
    border: "none"
  }
};
